<template>
  <v-container fluid class="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Container Expenses</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="stores"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- manifest template -->
              <template v-slot:item.view="{ item }">
                <v-btn :to="`/freight/expenses/${item.id}`" color="primary" text
                  ><v-icon left>mdi-eye</v-icon>
                  View Expenses
                </v-btn>
              </template>
              <!-- end -->
              <!-- manifest template -->
              <template v-slot:item.add="{ item }">
                <v-btn :to="`/freight/expenses/${item.id}`" color="accent" text
                  ><v-icon left>mdi-plus</v-icon>
                  Add Expense
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    search: "",
    loader: false,
    activeContainer: {},
    manifestDialog: false,
    selectedCustomer: null,
    customers: [],
    recordDialog: false,
    customerDialog: false,
    customerItem: {},
    manifestItem: {},
    manifestData: [],
    headers: [
      { text: "Container Label", value: "Name" },
      { text: "Total Lines", value: "Lines" },
      { text: "Date", value: "DocDate" },
      { text: "View", value: "view" },
      { text: "Add", value: "add" },
    ],
    manifestHeaders: [
      { text: "Customer", value: "CustomerName" },
      { text: "Phone Number", value: "PhoneNumber" },
      { text: "Line(s)", value: "Lines" },
      { text: "Cost / Line", value: "LineCost" },
      { text: "Total", value: "DocTotal" },
      { text: "Action", value: "action" },
    ],
    stores: [],
  }),
  computed: {
    manifestValue() {
      let total = 0;
      if (
        typeof this.manifestData != "undefined" &&
        this.manifestData.length > 0
      ) {
        return this.manifestData
          .map((item) => {
            let Lines;
            let LineCost;
            if (item.Lines) {
              Lines = item.Lines;
            } else {
              Lines = 0;
            }

            if (item.LineCost) {
              LineCost = item.LineCost;
            } else {
              LineCost = 0;
            }

            const amount = Lines * LineCost;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    manifestLines() {
      let total = 0;
      if (
        typeof this.manifestData != "undefined" &&
        this.manifestData.length > 0
      ) {
        return this.manifestData
          .map((item) => {
            let Lines;
            if (item.Lines) {
              Lines = item.Lines;
            } else {
              Lines = 0;
            }

            total = +Lines;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  methods: {
    addRecord() {},
    customerModal() {
      this.customerDialog = true;
    },
    inputChanged(data) {
      let Lines;
      let LineCost;
      if (data.Lines) {
        Lines = parseFloat(data.Lines);
      } else {
        Lines = 0;
      }
      if (data.LineCost) {
        LineCost = parseFloat(data.LineCost);
      } else {
        LineCost = 0;
      }

      const DocTotal = Lines * LineCost;

      // find item
      const currentItem = this.manifestData.find((record) => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.manifestData.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      currentItem.DocTotal = DocTotal;
      this.manifestData[pos] = currentItem;
    },
    openManifestDialog(data) {
      this.activeContainer = data;
      this.manifestDialog = true;
    },
    deleteRow(item) {
      const selectedRow = this.manifestData.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.manifestData.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.manifestData.splice(pos, 1);
    },
    setOrderItem(id) {
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/customers/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            // current item definition
            let currentItem = {};

            // set price list
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.CardCode = customer.id;
            currentItem.CustomerName = customer.Name;
            currentItem.PhoneNumber = customer.PhoneNumber;
            currentItem.Lines = null;
            currentItem.LineCost = self.activeContainer.LineCost;
            currentItem.DocTotal = 0;
            // end

            let initArray = [];
            initArray.push(currentItem);
            self.manifestData = [...self.manifestData, ...initArray];
            self.selectedCustomer = null;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    saveCustomer(data) {
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            self.customers = [...this.customers, customer];
            self.$refs.snackbar.show("Customer Added Successully", "green");
            self.customerDialog = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("btnLoader", false);
        });
    },
    saveManifest() {
      if (this.activeContainer.Lines != this.manifestLines) {
        this.$refs.snackbar.show("Container Lines Don't match!", "red");
      } else {
        const self = this;
        let data = {
          store_id: self.activeContainer.id,
          DocDate: new Date().toISOString().substr(0, 10),
          rows: self.manifestData,
        };
        const url = "/manifest";
        self.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.$router.push(
                `/freight/containers/manifest/${self.activeContainer.id}`
              );
              self.loader = false;
            } else {
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/get/containers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customers = res.ResponseData;
            customers.shift();
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getStores();
    this.getCustomers();
  },
};
</script>